import * as amplitude from "@amplitude/analytics-browser";
import { paymentMethodsLink } from "@redotech/redo-billing-common/billing/bills-link";
import XCloseIcon from "@redotech/redo-icons/x-close.svg";
import { TeamContext } from "@redotech/redo-merchant-app-common/team";
import { shopifyReturnsBillingEnforceFlag } from "@redotech/redo-return-core-common/returns-feature-flags";
import { hasAcceptedShopifyBilling } from "@redotech/redo-shopify-common/shopify-subscription";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { Link } from "@redotech/redo-web/link";
import { DATE_FORMAT } from "@redotech/redo-web/time";
import { memo, useContext, useState } from "react";
import { useLocation } from "react-router-dom";
import { BillingBannerEvents } from "./billing-events";
import { BillingAlertCtaButton } from "./failed-alert";
import * as failedAlertCss from "./failed-alert.module.css";

export const ShopifyReturnsBillingDeadlineAlert = memo(
  function ShopifyReturnsBillingDeadlineAlert() {
    const team = useContext(TeamContext);
    const [closed, setClosed] = useState(false);
    const location = useLocation();

    const hasAcceptedBilling = hasAcceptedShopifyBilling(
      team?.settings?.shopifySubscription?.[0],
    );
    const shutdownDate = team?.shopifyReturnsBillingShutdownDate
      ? new Date(team.shopifyReturnsBillingShutdownDate)
      : null;

    if (
      !team ||
      team.featureFlags?.[shopifyReturnsBillingEnforceFlag.key] !== true ||
      !team.shopifyReturnsBillingRequiredSince ||
      hasAcceptedBilling ||
      team.billingMethod === "fake" ||
      team.billingMethod === "offline" ||
      closed
    ) {
      return null;
    }

    return (
      <div className={failedAlertCss.header}>
        <div>
          Your Redo returns billing has not been accepted in Shopify. Please
          accept billing in{" "}
          <Link to={paymentMethodsLink(team._id)}>billing settings.</Link>
          {shutdownDate && (
            <>
              <br />
              The return portal will be disabled on{" "}
              {DATE_FORMAT.format(shutdownDate)}.
            </>
          )}
        </div>
        <BillingAlertCtaButton
          currentPath={location.pathname}
          onClick={() =>
            amplitude.track(
              BillingBannerEvents.SHOPIFY_BILLING_DEADLINE_VIEW_BILLING_CLICKED,
            )
          }
          text="Accept billing"
          to={paymentMethodsLink(team._id)}
        />
        <RedoButton
          aria-label="Dismiss"
          IconLeading={XCloseIcon}
          onClick={() => {
            amplitude.track(
              BillingBannerEvents.SHOPIFY_BILLING_DEADLINE_DISMISSED,
            );
            setClosed(true);
          }}
          size="sm"
        />
      </div>
    );
  },
);
